/**
 * RequireAuth — route guard.
 * Redirects to /login if there's no session. Renders nothing while the
 * initial session check is in flight (loading=true) to avoid flashing
 * /login on every reload.
 */

import { type ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router'
import { useAuthStore } from '@/store/authStore'
import { PATHS }        from '@/router/paths'

export function RequireAuth({ children }: { children: ReactNode }): ReactNode {
  const session = useAuthStore((s) => s.session)
  const loading = useAuthStore((s) => s.loading)
  const location = useLocation()

  if (loading) {
    return (
      <div
        role="status"
        aria-live="polite"
        style={{
          minHeight:      '100vh',
          display:        'flex',
          alignItems:     'center',
          justifyContent: 'center',
          color:          'var(--brand-neutral-500)',
          fontFamily:     'var(--brand-font-family)',
        }}
      >
        Loading…
      </div>
    )
  }

  if (!session) {
    return <Navigate to={PATHS.login} replace state={{ from: location.pathname }} />
  }

  return <>{children}</>
}
